import { gql } from "@apollo/client";

export const GET_TASKTYPES = gql`
  query taskTypes {
    taskTypes {
      Id
      taskName
    }
  }
`;
